<div class="container">
  <div class="btn btn-secondary arrow return mb-4 mt-4" routerLink="/">Retour</div>
  <h1 class="title">{{ page.title }}</h1>
  <div class="page-content" [innerHtml]="page.content"></div>
</div>
